import { LaborCodeDTO } from "../models/WarrantyClaimManagement";
import { setBoatSeriesList, setCountryList, setDesignationTypes, setYearList } from "../store/slices/Lookup/LookupSlice";
import { 
    setClaimCauseCodeList, 
    setClaimFaultTypeList, 
    setClaimStatusList, 
    setLookupsLoaded 
} from "../store/slices/WarrantyClaim/WarrantyClaimSlice";
import agent from "./agent";
import { ApiFactory } from "./ApiFactory";

export default class LookupApi {

    private apiFactory: ApiFactory;
    constructor(apiFactory: ApiFactory) {
      this.apiFactory = apiFactory;
    }

    //Lookups that don't change that often can and should be stored in the store and can be accessed without making subsequent calls to APIs to retrieve
    //the information.

    //For lookups anything that can be cached for later use should via the store.
    getCountryList = async () => {
        try {

            var value = this.apiFactory.store.getState().reducer.Lookup.countryList;

            if(value.length <= 0) {
                const response = await agent.api.get(`/lookup/getcountries`, null);
                this.apiFactory.store.dispatch(setCountryList(response));

                value = this.apiFactory.store.getState().reducer.Lookup.countryList;
            }

            return value;
        }
        catch (error) {
            throw error;
        }
    }

    //Called when the app first loads for an authenticated user. Stores information in state that can be used throughout the app.
    getBoatSeriesList = async () => {
        const response = await agent.api.get(`/lookup/getboatserieslist`, null);
        this.apiFactory.store.dispatch(setBoatSeriesList(response));
    }

    getYearList = async () => {
        const response = await agent.api.get(`/lookup/getyearlist`, null);
        this.apiFactory.store.dispatch(setYearList(response));
    }

    getDesignationType = async () => {

        var value = this.apiFactory.store.getState().reducer.Lookup.designationTypes;

        if(value.length <= 0) {
            const response = await agent.api.get(`/lookup/getdesignationtypes`, null);
            this.apiFactory.store.dispatch(setDesignationTypes(response));

            value = this.apiFactory.store.getState().reducer.Lookup.designationTypes;
        }

        return value;
    }

    getClaimStatusList = async () => {
        try {

            var value = this.apiFactory.store.getState().reducer.WarrantyClaim.claimStatusList;

            if(value.length <= 0) {
                const response = await agent.api.get(`/Lookup/getclaimstatuslist`, null);
                this.apiFactory.store.dispatch(setClaimStatusList(response));

                value = this.apiFactory.store.getState().reducer.WarrantyClaim.claimStatusList;
            }

            return value;
        }
        catch (error) {
            throw error;
        }
    };

    getClaimFaultTypeList = async () => {
        try {
            var value = this.apiFactory.store.getState().reducer.WarrantyClaim.claimFaultTypeList;

            if(value.length <= 0) {
                const response = await agent.api.get(`/Lookup/getclaimfaultlist`, null);
                this.apiFactory.store.dispatch(setClaimFaultTypeList(response));

                value = this.apiFactory.store.getState().reducer.WarrantyClaim.claimFaultTypeList;
            }

            return value;
        }
        catch (error) {
            throw error;
        }
    }

    getClaimCauseCodeList = async () => {
        try {
            var value = this.apiFactory.store.getState().reducer.WarrantyClaim.claimCauseCodeList;

            if(value.length <= 0) {
                const response = await agent.api.get(`/Lookup/getclaimcausecodelist`, null);
                this.apiFactory.store.dispatch(setClaimCauseCodeList(response));

                value = this.apiFactory.store.getState().reducer.WarrantyClaim.claimCauseCodeList;
            }

            return value;
        }
        catch (error) {
            throw error;
        }
    }

    getLaborCodes = async () => {
        try {
            const response: LaborCodeDTO[] = await agent.api.get(`/Lookup/getlaborcodes`, null);
            return response;
        }
        catch(error) {
            throw error;
        }

    }

    loadClaimLookupsToStore = async () => {

        await this.getClaimStatusList();
        await this.getClaimFaultTypeList();
        await this.getClaimCauseCodeList();
        await this.apiFactory.partsApi.getPartCategories();

        this.apiFactory.store.dispatch(setLookupsLoaded(true));
    }
}